import { render, staticRenderFns } from "./CustomElSelect.vue?vue&type=template&id=6fdf5d1d&scoped=true&"
import script from "./CustomElSelect.vue?vue&type=script&lang=js&"
export * from "./CustomElSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomElSelect.vue?vue&type=style&index=0&id=6fdf5d1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdf5d1d",
  null
  
)

export default component.exports